import styled, { css } from "styled-components";
import { IStyledBorderCard,IStyledContainerCard } from "./interface";

const styledColors = {
	red: "var(--red)",
	green: "var(--green)",
	blue: "var(--blue)",
	grey: "var(--grey)",
	yellow: "var(--yellow)",
	purple: "var(--purple)",
	orange: "var(--orange)",
	black: "var(--black)"
};

const maxCards = {
	"1": css`
            flex: 0 0 100%;
        `,
	"2": css`
            flex: 0 0 50%;

            @media(max-width: 1000px){
                flex-basis: 100%;
            }
        `,
	"3": css`
            flex: 0 0 33.33%;

            @media(max-width: 1000px){
                flex-basis: 50%;
            }

            @media(max-width: 600px){
                flex-basis: 100%;
            }
        `,
	"4": css`
            flex: 0 0 25%;

            @media(max-width: 1200px){
                flex-basis: 33.33%;
            }
            
            @media(max-width: 1000px){
                flex-basis: 50%;
            }

            @media(max-width: 600px){
                flex-basis: 100%;
            }
        `
};

const Container = styled.div<IStyledContainerCard>`
    display: flex;
    
    ${(props) => maxCards[props.maxCards||"3"]}
   
`;

export const ContainerWithMargin = styled.div<IStyledBorderCard>`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    margin: 4px;
    padding-left: 4px;

    background: var(--card-background);
    box-shadow: 0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%); 
    border: 1px solid var(--border-color);
    border-left: none;

    position: relative;
    
    &::after{
        content: "";
        position: absolute;
        display: flex;
        top: -1px;
        left: 0;
        height: calc(100% + 1px);
        width: 4px;
        background: ${(props) => styledColors[props.color]};
    }

`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 0 4px;
    border-bottom: 1px solid var(--border-color);
    span.title{
        font-weight: 700;
        font-size: 0.9rem;
        color: var(--default-color-font);
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        word-break: break-word;
        display: -webkit-box;
    }
`;

export const Body = styled.div`
    display: flex;
    align-items: center;
    padding: 5px;
    color: var(--default-color-font);
`;

export const DivContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    flex-wrap: wrap;
    font-size: 0.82rem;
`;

export const DivContentPercetage = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding: 5px;

    .sc-cTAqQK{
        width: auto !important;
    }
`;


export default Container;

